import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { AirCarrierActions, AirCarrierActionTypes } from './air-carrier.actions';
import { AirCarrierEntity } from './air-carrier.model';

export type AirCarrierEntities = EntityState<AirCarrierEntity>;

export const adapter: EntityAdapter<AirCarrierEntity> = createEntityAdapter<AirCarrierEntity>();

export const initialState: AirCarrierEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): AirCarrierEntities {
  const action = incomingAction as AirCarrierActions;
  switch (action.type) {
    case AirCarrierActionTypes.AddAirCarrier: {
      return adapter.addOne(action.payload.airCarrier, state);
    }

    case AirCarrierActionTypes.UpsertAirCarrier: {
      return adapter.upsertOne(action.payload.airCarrier, state);
    }

    case AirCarrierActionTypes.AddAirCarriers: {
      return adapter.addMany(action.payload.airCarriers, state);
    }

    case AirCarrierActionTypes.UpsertAirCarriers: {
      return adapter.upsertMany(action.payload.airCarriers, state);
    }

    case AirCarrierActionTypes.UpdateAirCarrier: {
      return adapter.updateOne(action.payload.airCarrier, state);
    }

    case AirCarrierActionTypes.UpdateAirCarriers: {
      return adapter.updateMany(action.payload.airCarriers, state);
    }

    case AirCarrierActionTypes.DeleteAirCarrier: {
      return adapter.removeOne(action.payload.id, state);
    }

    case AirCarrierActionTypes.DeleteAirCarriers: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case AirCarrierActionTypes.LoadAirCarriers: {
      return adapter.setAll(action.payload.airCarriers, state);
    }

    case AirCarrierActionTypes.ClearAirCarriers: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
